<div class="top-bar">
  <div class="left-section">
    <h6 *ngIf="pageTitle" class="mt-4 mb-0">{{ pageTitle }}</h6>
    <p *ngIf="pageSubTitle; else emptySubtitle">{{ pageSubTitle }}</p>
    <ng-template #emptySubtitle><p class="subtitle">&nbsp;</p></ng-template>
  </div>
  <div class="right-section">

    <ng-container *ngIf="isLoading; else pageContent">
      <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
    </ng-container>
    <ng-template #pageContent>
      <div class="user-info" *ngIf="userDetail">
        <div>
          <div class="name">
            {{ userDetail.first_name }} {{ userDetail.last_name }}
          </div>
          <div class="email" [matTooltip]="userDetail.phone_email">
            {{ userDetail.phone_email.length > 20
                ? (userDetail.phone_email | slice : 0 : 20) + "..."
                : userDetail.phone_email}}
          </div>
        </div>
        <div class="avatar">
          {{ userDetail.first_name[0] }}{{ userDetail.last_name[0] }}
        </div>
      </div>
    </ng-template>
  </div>
</div>
